import React, {
  Component, useState, useEffect
} from 'react';
import {
  connect
} from 'react-redux';

import Button from '../../../components/UI/Button/Button';
import Spinner from '../../../components/UI/Spinner/Spinner';
import classes from './LogLink.css';
import Box from '../../../hoc/Box/Box';
import axios from '../../../axios-local-api';
import Input from '../../../components/UI/Input/Input';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler'
import * as actions from '../../../store/actions/index';
import Clipboard from 'react-clipboard.js';
import Tooltip from 'react-tooltip-lite';

const LogLink = (props) => {
 const [showTooltip, setShowTooltip] = useState(false);
 useEffect(() => {
 return () => {
   setShowTooltip(false);
 }
 }, []);

 const handleShowToolTip = () => {
  setShowTooltip(true);
  setTimeout(() => {
    setShowTooltip(false);
  }, 3000);
 }
  return (  
    <div>
      <h2>Get Log Link</h2>
      {/* <p>Log Data has been successfully extracted.</p> */}
      {/* <p style={{wordBreak: 'break-word'}}>{this.props.logsLink}</p> */}
     <div className={classes.LogLink}>
      <textarea value={props.logsLink} rows="3" cols="40" className={classes.textarea}/>
              {/* <div className={classes.HeaderRow}> */}
        {showTooltip && <div className={classes.Tooltip}>Link copied</div>}
        <Clipboard  id="copylinkbtn" className={classes.RegularButton} data-clipboard-text={props.logsLink} onClick={handleShowToolTip}>
          Copy 
        </Clipboard>
             
              {/* </div> */}
      </div>
    </div> 
);
}

const mapStateToProps = state => {
  return {
  }
};

const mapDispatchToProps = dispatch => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(LogLink, axios));
